import { render, staticRenderFns } from "./attachment-thumbnail.vue?vue&type=template&id=2af778c6&"
import script from "./attachment-thumbnail.vue?vue&type=script&lang=js&"
export * from "./attachment-thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./attachment-thumbnail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports